import Reveal from "@/components/Reveal";
import { Star, Quote } from "lucide-react";

const REVIEWS = [
  {
    title: "The Best Decision We Made",
    text: "Working with Shonta Solutions has been such a positive experience. Their professionalism, communication, and attention to detail really stand out. They make property management feel simple and organized, and it's reassuring knowing there's a dedicated team handling the day-to-day responsibilities.",
  },
  {
    title: "A Huge Weight Off Our Shoulders",
    text: "As property owners, we wanted to generate rental income without taking on another full-time responsibility. Shonta Solutions understood exactly what we needed. From preparing the property to coordinating guests and managing daily operations, they've made the experience much less stressful.",
  },
  {
    title: "Professional From Day One",
    text: "What impressed us most about Shonta Solutions was how clearly they explained everything. Their onboarding process was straightforward, their communication was excellent, and they treated our property with care. It's refreshing to work with a company that values the owner's peace of mind.",
  },
  {
    title: "Finally, A Team That Handles Everything",
    text: "We love owning rental property, but managing bookings, guest questions, and cleaning schedules can become overwhelming. Shonta Solutions brought organization and consistency to the process. Having a reliable team to communicate with has made a tremendous difference.",
  },
  {
    title: "They Truly Care About Their Clients",
    text: "Shonta Solutions doesn't make you feel like just another property on their list. They take the time to answer questions, explain their recommendations, and make sure you're comfortable with the process. Their customer service and genuine dedication are what make them stand out.",
  },
  {
    title: "Highly Recommend Their Service",
    text: "If you're a homeowner considering short-term or furnished rental management, Shonta Solutions is worth speaking with. Their approach is professional, their services are comprehensive, and their team makes understanding the process easy. It's a company that puts real effort into building strong relationships with property owners.",
  },
];

export default function Testimonials() {
  return (
    <section id="reviews" className="py-20 sm:py-28" data-testid="testimonials-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <Reveal className="text-center">
          <p className="text-sm font-bold tracking-[0.2em] uppercase text-[#FF5A5F]">Client Reviews</p>
          <h2 className="mt-3 text-3xl sm:text-4xl font-bold tracking-tight text-[#222] max-w-3xl mx-auto">
            Confidence You Can Feel. Service You Can Count On.
          </h2>
        </Reveal>

        <div className="mt-12 grid md:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
          {REVIEWS.map((review, i) => (
            <Reveal key={review.title} delay={(i % 3) * 0.08}>
              <article
                data-testid={`testimonial-card-${i + 1}`}
                className="h-full bg-white border border-[#EBEBEB] rounded-2xl p-8 shadow-[0_6px_16px_rgba(0,0,0,0.06)] transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_12px_24px_rgba(0,0,0,0.12)]"
              >
                <div className="flex items-center gap-1" aria-label="5 out of 5 stars">
                  {[...Array(5)].map((_, s) => (
                    <Star key={s} className="w-5 h-5 text-[#FF5A5F]" fill="currentColor" />
                  ))}
                </div>
                <h3 className="mt-4 text-lg font-bold text-[#222]">{review.title}</h3>
                <p className="mt-3 text-[15px] leading-relaxed text-[#5a5a5a]">
                  &ldquo;{review.text}&rdquo;
                </p>
                <div className="mt-6 pt-5 border-t border-[#EBEBEB] flex items-center gap-3">
                  <span className="w-10 h-10 rounded-full bg-[#FFD3C6]/60 flex items-center justify-center">
                    <Quote className="w-4 h-4 text-[#E0484D]" />
                  </span>
                  <div>
                    <p className="text-sm font-bold text-[#222]">Property Owner</p>
                    <p className="text-xs font-semibold text-[#717171] mt-0.5">Shonta Solutions Client</p>
                  </div>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
